var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.247 16.494A8.247 8.247 0 1 1 8.247 0a8.247 8.247 0 0 1 0 16.494zm1.597-7.717c-.344 0-.647.164-.846.415l-1.839-.94c.025-.09.042-.183.042-.281 0-.106-.02-.206-.05-.304l1.831-.936c.197.263.509.434.862.434a1.082 1.082 0 1 0-1.082-1.083c0 .098.017.191.042.281l-1.839.94a1.078 1.078 0 0 0-1.93.668c0 .598.485 1.083 1.083 1.083.354 0 .665-.172.863-.435l1.83.936a1.07 1.07 0 0 0-.05.305 1.083 1.083 0 1 0 1.083-1.083z",
  fill: "#FFF",
  fillRule: "evenodd"
})));
export default SvgShare;